import React from "react";
import Button from "../Helpers/Button/Button";

export default function AntButton({ item, activeInput }) {
	return (
		<>
			<Button
				htmlType={item?.btnType}
				key={activeInput}
				style={item?.css}
				type="primary"
			>
				{item?.title}
			</Button>
		</>
	);
}
